import React from 'react';
import ProjectIndexCard from './ProjectIndexCard';
import  ProjectModel from '../models/ProjectModel';
import '../App.css';

function ProjectIndex(props) {
  return (

    <div className="project-index">
    <div className="mobile">
    <div className="project-index-label page-pad">More Work</div>
    <div className="project-index-grid page-pad" style={{ display: 'grid', gridTemplateColumns: 'repeat(8, 1fr)', columnGap: 12 }}>
		<ProjectIndexCard projectModel={ProjectModel.Config2025}/>
		<ProjectIndexCard projectModel={ProjectModel.MakerWeek}/>
		<ProjectIndexCard projectModel={ProjectModel.ShapeOfSense}/>
		<ProjectIndexCard projectModel={ProjectModel.NYTimesRightToBeauty}/>
		<ProjectIndexCard projectModel={ProjectModel.YoungGuns}/>
		<ProjectIndexCard projectModel={ProjectModel.HighSnobiety}/>
		<ProjectIndexCard projectModel={ProjectModel.Spotify}/>
		<ProjectIndexCard projectModel={ProjectModel.BloombergBusinessweekCover}/>
		<ProjectIndexCard projectModel={ProjectModel.BloombergGreen}/>
		<ProjectIndexCard projectModel={ProjectModel.LATimesClimateChange}/>
		<ProjectIndexCard projectModel={ProjectModel.AppleArtText}/>
		<ProjectIndexCard projectModel={ProjectModel.Wired}/>
		<ProjectIndexCard projectModel={ProjectModel.RBMA}/>
<ProjectIndexCard projectModel={ProjectModel.Bandcamp}/>
		<ProjectIndexCard projectModel={ProjectModel.AdidasStateSneakers}/>
		<ProjectIndexCard projectModel={ProjectModel.Apple}/>
		<ProjectIndexCard projectModel={ProjectModel.Nike}/>
		<ProjectIndexCard projectModel={ProjectModel.BandcampExperimental}/>
		<ProjectIndexCard projectModel={ProjectModel.SpaceNinety8}/>
		<ProjectIndexCard projectModel={ProjectModel.CashApp}/>
		<ProjectIndexCard projectModel={ProjectModel.NYTimes}/>
		<ProjectIndexCard projectModel={ProjectModel.Atlantic}/>
		<ProjectIndexCard projectModel={ProjectModel.TheBaffler}/>
		<ProjectIndexCard projectModel={ProjectModel.Elsewhere}/>
		{/* Hidden:
		Config2025, MakerWeek, ShapeOfSense, TheVergeOfflineActivities,
		BloombergBusinessweekRealEstate, BloombergBusinessweekJunk, NewYorker_BitterPill,
		LuxMagazine, NewYorker_MDMA, NewYorker, BloombergBusinessweekSpotify,
		Medium, BulletinSwag, BulletinLWY, Bulletin, TheVerge
		*/}
    </div>
	 </div>
    </div>

  )
}

export default ProjectIndex;
